import { FC } from 'react';
import EmployeeSectionWrapper from 'domain/people/employee/shared/EmployeeSectionWrapper';
import LeavePeriodField from '../field/LeavePeriodField';
import LeaveColumnLayout from '../layout/LeaveColumnLayout';
import LeaveTakenField from '../field/LeaveTakenField';
import LeavesDataGridLayout from '../layout/LeavesDataGridLayout';
import BalanceDisplayField from '../field/BalanceDisplayField';
import AvailableField from '../field/AvailableField';
import SickDaysSectionHeader from '../shared/SickDaysSectionHeader';
import { ProcessedLeaveYear } from '../../shared/types';
import LeaveDetailsField from '../field/LeaveDetailsField';
import { RelatedList, RelationListLayout } from 'framework/list';
import { Data } from 'framework/types';

interface SickDaysSectionProps {
  getSickDaysDataMethod: () => Promise<{ result: ProcessedLeaveYear[] }>;
  compactMode?: boolean;
  defaultExpandedItems?: (data: ProcessedLeaveYear) => boolean;
  hideShowDetailsButtons?: boolean;
}

const SickDaysSection: FC<SickDaysSectionProps> = ({
  getSickDaysDataMethod,
  compactMode = false,
  defaultExpandedItems,
  hideShowDetailsButtons = false,
}) => {
  const isExpandableItem = (data: Data<ProcessedLeaveYear>) => {
    return data?.leaves?.length > 0;
  };

  return (
    <EmployeeSectionWrapper>
      <RelatedList getDataMethod={getSickDaysDataMethod}>
        <RelationListLayout header={<SickDaysSectionHeader />}>
          <LeavesDataGridLayout
            expandable
            isExpandableItem={isExpandableItem}
            expandableSection={<LeaveDetailsField hideShowDetailsButtons={hideShowDetailsButtons} />}
            defaultExpandedItems={defaultExpandedItems}
          >
            <LeaveColumnLayout label="Period" size={compactMode ? 12 : 4}>
              <LeavePeriodField />
            </LeaveColumnLayout>
            {!compactMode && (
              <LeaveColumnLayout label="Balance" size={2}>
                <BalanceDisplayField balanceField="sickDaysTotalBalance" />
              </LeaveColumnLayout>
            )}

            {!compactMode && (
              <LeaveColumnLayout label="Available" size={3.5}>
                <AvailableField balanceField="sickDaysRemainedBalance" expiredBalanceField="sickDaysExpiredBalance" />
              </LeaveColumnLayout>
            )}

            {!compactMode && (
              <LeaveColumnLayout label="Taken" size={2.5}>
                <LeaveTakenField />
              </LeaveColumnLayout>
            )}
          </LeavesDataGridLayout>
        </RelationListLayout>
      </RelatedList>
    </EmployeeSectionWrapper>
  );
};

export default SickDaysSection;
